import { http } from '../index';

export const UpdateAccessToken = () =>
  http.post('auth/refresh-token', {
    accessToken: localStorage.getItem('accessToken'),
    refreshToken: localStorage.getItem('refreshToken'),
  });
